<template>
    <div>
        <div class="container-fluid">
            <!-- Head -->
            <div class="d-flex align-items-center justify-content-between pt-4 mb-4">
                <div class="d-block">
                    <div class="h1-lg display-tektur m-0">PM UTBK Alumni</div>
                </div>
                <div class="d-block">
                    <button type="button" v-on:click="$parent.$parent.passing_grade_alumni_utbk_form();" class="btn btn-primary btn-lg btn-s-1">
                        <div class="btn-s-1-inner"><i class="fa-solid fa-circle-plus fa-lg me-3"></i>Tambah Data</div>
                    </button>
                </div>
            </div>
            <div class="d-block">
                <ul class="nav nav-tabs border-0">
                    <li class="nav-item">
                        <a class="nav-link" :class="tabActive == 'tab_university' ? 'active':''" href="javascript:void(0)" id="tab_university" v-on:click="changeTab('tab_university')">Universitas</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="tabActive == 'tab_school' ? 'active':''" href="javascript:void(0)" id="tab_school" v-on:click="changeTab('tab_school')">Sekolah</a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Data -->
        <div class="card rounded-0 m-0 bg-card-trans-3">
            <div class="card-header">
                <div class="input-group input-group-flush input-group-merge input-group-reverse">
                    <input class="form-control list-search" type="search" placeholder="Cari data disini..." v-model="keywords" v-on:keyup.enter="getData">
                        <span class="input-group-text">
                        <i class="fa-solid fa-search"></i>
                    </span>
                </div>
                <div v-if="tabActive == 'tab_university' || tabActive == 'tab_school'" class="d-flex align-items-center">
                    <div class="d-block me-3 text-muted">Filter:</div>
                    <div class="d-block me-2" style="width:250px;">
                        <div class="form-select-wrapper">
                            <v-select
                                :options="dataUniversity"
                                label="name"
                                v-model="filter.university"
                                placeholder="Semua Universitas"
                                append-to-body
                                @input='set_university'
                                >
                            </v-select>
                        </div>
                    </div>
                    <div class="d-block me-2" style="width:250px;">
                        <div class="form-select-wrapper">
                            <v-select
                                :options="dataMajor"
                                label="name"
                                v-model="filter.major"
                                placeholder="Semua Jurusan"
                                append-to-body
                                @input='set_major'
                                >
                            </v-select>
                        </div>
                    </div>
                    <div class="d-bloc me-2" style="width:250px;">
                        <select class="form-select form-select-dark" v-model="education_level" v-on:change="getData()">
                            <option value="">Semua Jenjang</option>
                            <option v-for="(item, index) in dataEducationLevel" :key="index" :value="item">{{ item }}</option>
                        </select>
                    </div>
                </div>
                <div v-if="tabActive == 'tab_school'" class="d-flex align-items-center d-none">
                    <div class="d-block me-3 text-muted">Filter:</div>
                    <div class="d-bloc me-2" style="width:200px;">
                        <select class="form-select form-select-dark">
                            <option value="">Semua Sekolah</option>
                            <option>SMA 1 Bandung</option>
                        </select>
                    </div>
                    <div class="d-block" style="width:200px;">
                        <select class="form-select form-select-dark">
                            <option value="">Semua Kota</option>
                            <option>Bandung</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="dataFetch" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-muted"><i class="fa-solid fa-spin fa-spinner fa-lg"></i></div>
                        <div class="d-block text-sm text-muted ">Loading...</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="tabActive == 'tab_university'">
            <div v-if="!dataFetch && dataList.length > 0" class="card rounded-0 m-0 bg-card-trans-3">
                <div data-simplebar class="table-responsive" style="overflow-y:auto; height:72.9vh;">
                    <table class="table table-sm table-hover card-table th-sticky">
                        <thead>
                            <tr>
                                <th class="text-center">No</th>
                                <th>Universitas</th>
                                <th>Jurusan</th>
                                <th class="text-center">PM UTBK</th>
                                <th class="text-center">Alumni</th>
                                <th class="text-center">Tergenerate</th>
                                <th>Nilai UTBK</th>
                            </tr>
                        </thead>                        
                        <tbody class="list fs-base">
                            <tr v-for="(item, index) in dataList" :key="index">
                                <td class="text-center">
                                    {{ (index + 1) + (pagination.current_page - 1) * pagination.limit }}
                                </td>
                                <td class="font-bold data-nama-Mata Pelajaran">
                                    <div class="d-block font-bold">{{item.university_name}}</div>
                                    <span v-if="item.relation" class="badge bg-primary"><i class="fa-solid fa-link me-2"></i>Sudah Berelasi</span>
                                </td>
                                <td>{{ item.major_name }}</td>
                                <td class="text-center">
                                    <div class="box-score">
                                        <span>{{ item.score_pg }}</span>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <span class="display-tektur h2">{{ item.total_users }}</span>
                                </td>
                                <td class="text-center">
                                    <span class="display-tektur h2">{{ item.generate_score }} / {{ item.total_users }}</span>
                                </td>
                                <td>
                                    <button type="button" class="btn btn-white btn-sm" v-on:click="detailItem(item)">Detail<i class="fa-solid fa-arrow-right ms-2"></i></button>
                                </td>                                
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div aria-label="navigation" class="card-footer d-flex justify-content-between">

                    <!-- Pagination (prev) -->
                    <ul class="list-pagination-prev pagination pagination-tabs card-pagination">
                        <li class="page-item">
                            <a class="page-link ps-0 pe-4 border-end border-c-1" :class="pagination.current_page <= 1 ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('prev')">
                                <i class="fa-solid fa-angle-left me-3"></i>Sebelumnya
                            </a>
                        </li>
                    </ul>

                    <v-pagination v-model="pagination.current_page" :page-count="pagination.total_pages" :classes="pagination.style" :labels="pagination.anchor_text" v-on:change="getData()"></v-pagination>

                    <!-- Pagination (next) -->
                    <ul class="list-pagination-next pagination pagination-tabs card-pagination">
                        <li class="page-item">
                            <a class="page-link ps-4 pe-0 border-start border-c-1" :class="pagination.current_page >= pagination.total_pages ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('next')">
                                Selanjutnya<i class="fa-solid fa-angle-right ms-3"></i>
                            </a>
                        </li>
                    </ul>

                </div>            
            </div>
        </div>

        <div v-if="tabActive == 'tab_school'">
            <div v-if="!dataFetch && dataList.length > 0" class="card rounded-0 m-0 bg-card-trans-3">
                <div data-simplebar class="table-responsive" style="overflow-y:auto; height:72.9vh;">
                    <table class="table table-sm table-hover card-table th-sticky">
                        <thead>
                            <tr>
                                <th class="text-center">No</th>
                                <th>Sekolah</th>
                                <th>Kota</th>
                                <th class="text-center">PM UTBK</th>
                                <th class="text-center">Alumni</th>
                                <th class="text-center">Tergenerate</th>
                                <th>Nilai UTBK</th>
                            </tr>
                        </thead>                        
                        <tbody class="list fs-base">
                            <tr v-for="(item, index) in dataList" :key="index">
                                <td class="text-center">
                                    {{ (index + 1) + (pagination.current_page - 1) * pagination.limit }}
                                </td>
                                <td class="font-bold data-nama-Mata Pelajaran">
                                    <div class="d-block font-bold">{{item.school_name}}</div>
                                    <span v-if="item.relation" class="badge bg-primary"><i class="fa-solid fa-link me-2"></i>Sudah Berelasi</span>
                                </td>
                                <td>{{ item.school_city_name }}</td>
                                <td class="text-center">
                                    <div class="box-score">
                                        <span>{{ item.score_pg }}</span>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <span class="display-tektur h2">{{ item.total_users }}</span>
                                </td>
                                <td class="text-center">
                                    <span class="display-tektur h2">{{ item.generate_score }} / {{ item.total_users }}</span>
                                </td>
                                <td>
                                    <button type="button" class="btn btn-white btn-sm" v-on:click="detailItem(item)">Detail<i class="fa-solid fa-arrow-right ms-2"></i></button>
                                </td>                                
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div aria-label="navigation" class="card-footer d-flex justify-content-between">

                    <!-- Pagination (prev) -->
                    <ul class="list-pagination-prev pagination pagination-tabs card-pagination">
                        <li class="page-item">
                            <a class="page-link ps-0 pe-4 border-end border-c-1" :class="pagination.current_page <= 1 ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('prev')">
                                <i class="fa-solid fa-angle-left me-3"></i>Sebelumnya
                            </a>
                        </li>
                    </ul>

                    <v-pagination v-model="pagination.current_page" :page-count="pagination.total_pages" :classes="pagination.style" :labels="pagination.anchor_text" v-on:change="getData()"></v-pagination>

                    <!-- Pagination (next) -->
                    <ul class="list-pagination-next pagination pagination-tabs card-pagination">
                        <li class="page-item">
                            <a class="page-link ps-4 pe-0 border-start border-c-1" :class="pagination.current_page >= pagination.total_pages ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('next')">
                                Selanjutnya<i class="fa-solid fa-angle-right ms-3"></i>
                            </a>
                        </li>
                    </ul>

                </div>            
            </div>
        </div>

        <div v-if="!dataFetch && emptyState" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                        <div class="d-block text-sm text-muted ">Data tidak ditemukan.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vPagination from 'vue-plain-pagination'
export default {
    name: 'PassingGradeAlumniUtbkMain',
    metaInfo: {
        title: 'PM UTBK Alumni',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    components: {
        vPagination
    },
    data() {
        return {
            filter : {
                university : [],
                major      : []
            },
            emptyState  : false,
            dataFetch   : false,
            dataList    : [],
            keywords    : "",
            tabActive   : 'tab_university',
            pagination: {
                current_page    : 1,
                total_pages     : 0,
                limit           : 50,
                style: {
                    ul: 'list-pagination pagination pagination-tabs card-pagination',
                    li: 'page-item',
                    a: 'page',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'                
                },
                anchor_text: {
                    first: '',
                    prev: '',
                    next: '',
                    last: ''
                }
            },
            dataUniversity : [],
            university_id : '',
            dataMajor : [],
            major_id : '',
            dataEducationLevel : ['D3','D4','S1'],
            education_level : ''
        }
    },
    created() {
        this.getUniversity();
        this.getMajor();
        this.changeTab(this.tabActive);
    },
    methods: {
        changeTab: function(params="") {
            this.tabActive = params;
            this.getData();
        },
        getData: function() {
            let uri         = process.env.VUE_APP_APIHOST+'passing-grade-alumni/list';

            this.dataFetch  = true;                
            this.$http.get(uri,{
                params : {
                    keywords    : this.keywords,
                    page        : this.pagination.current_page,
                    limit       : this.pagination.limit,
                    tab_active  : this.tabActive,
                    group       : 'utbk',
                    university_id   : this.university_id,
                    major_id   : this.major_id,
                    education_level : this.education_level
                }
            }).then(res => {
                this.emptyState                 = false;
                this.dataFetch                  = false;                
                this.dataList                   = res.data.data;
                this.pagination.total_pages     = res.data.total_page;

                if(this.dataList.length < 1) {
                    this.emptyState = true;
                }
            });
        },
        pagination_handle: function(params) {
            if(params == 'next') {
                if(this.pagination.current_page < this.pagination.total_pages) {
                    this.pagination.current_page = this.pagination.current_page+1;
                    this.getData();
                }
            }

            if(params == 'prev') {
                if(this.pagination.current_page > 1) {
                    this.pagination.current_page = this.pagination.current_page-1;
                    this.getData();
                }
            }
        },
        detailItem: function(item) {
            this.$parent.$parent.passing_grade_alumni_utbk_detail(item);
        },
        getUniversity: function() {
            let uri         = process.env.VUE_APP_APIHOST+'university/list';
            this.$http.get(uri,{
                params : {
                    limit    : 1000
                }
            }).then(res => {
                this.dataUniversity = res.data.data;
            });
        },
        getMajor: function() {
            this.major_id = "";
            let uri         = process.env.VUE_APP_APIHOST+'master-major/list';
            this.$http.get(uri).then(res => {
                this.dataMajor = res.data.data;
            });
        },
        set_university: function() {
            if (this.filter.university !== undefined && this.filter.university !== null) {
                this.university_id = this.filter.university.id;
            }  else {
                this.university_id = "";
            }
            this.getData();
        },
        set_major: function() {
            if (this.filter.major !== undefined && this.filter.major !== null) {
                this.major_id = this.filter.major.id;
            }  else {
                this.major_id = "";
            }
            this.getData();
        }        
    }
}
</script>
